
import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { v4 as uuidv4 } from "uuid";

let activeNotifications = [];
const MAX_NOTIFICATIONS = 3;

function addLimitedNotification(notification) {
  if (activeNotifications.length >= MAX_NOTIFICATIONS) {
    // Remove oldest
    const oldestId = activeNotifications.shift();
    Store.removeNotification(oldestId);
  }

  // Generate a custom ID so we can track it
  const id = uuidv4();

  Store.addNotification({
    ...notification,
    id, // attach custom ID
  });

  activeNotifications.push(id);
}

const Notification = ({ title, message, type, insert = "top" }) => {
  addLimitedNotification({
    title,
    message,
    type,
    insert,
    container: "bottom-left",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 3000,
      onScreen: true,
      pauseOnHover: true,
    },
    slidingExit: {
      duration: 800,
      timingFunction: "ease-out",
      delay: 0,
    },
  });
};

export { Notification };
